import React from "react";
import { Layout, Menu } from "antd";
import {
  UserOutlined,
  CalendarOutlined,
  PushpinOutlined,
  EnvironmentOutlined,
  SettingOutlined,
  TeamOutlined,SmileOutlined,
  CustomerServiceOutlined
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { EditNoteOutlined, HomeRepairServiceOutlined } from "@mui/icons-material";

const { Sider } = Layout;

const SidebarMenu = ({ collapsed, onCollapse, activeKey, onMenuClick, profile }) => {
  const { t } = useTranslation();

  return (
    <Sider
      collapsed={collapsed}
      onCollapse={onCollapse}
      width={200}
      collapsedWidth={80}
      className="user-profile-sider"
    >
      <Menu
        mode="inline"
        selectedKeys={[activeKey]}
        onClick={({ key }) => onMenuClick(key)}
        theme="dark"
      >
        <Menu.Item key="profile" icon={<UserOutlined />}>
          {t("sidebar.profile")}
        </Menu.Item>
        {/* Event Types menu removed as requested */}

        {profile?.roles?.some((role) => role.name === "COMPANYREQUESTVALIDATOR") && (
          <Menu.Item key="company-requests" icon={<PushpinOutlined />}>
            {t("sidebar.companyRequests")}
          </Menu.Item>
        )}

        {profile?.type === "Pro" && (
          <>
            <Menu.Item key="company-preferences" icon={<EnvironmentOutlined />}>
              {t("sidebar.preferences")}
            </Menu.Item>
            <Menu.Item key="company-services" icon={<HomeRepairServiceOutlined />}>
              {t("sidebar.services")}
            </Menu.Item>
            
            <Menu.Item key="team-members" icon={<TeamOutlined />}>
              {t("sidebar.TeamMembers")}
            </Menu.Item>
                        
            <Menu.Item key="clients" icon={<SmileOutlined />}>
              {t("sidebar.clients")}
            </Menu.Item>            
                           
            <Menu.Item key="company-websiteeditor" icon={<EditNoteOutlined />}>
              {t("sidebar.websiteeditor")}
            </Menu.Item>           

          </>
        )}
      </Menu>
    </Sider>
  );
};

export default SidebarMenu;


// import React from "react";
// import { Layout, Menu } from "antd";
// import {
//   UserOutlined,
//   PushpinOutlined,
//   EnvironmentOutlined,
//   SettingOutlined,
// } from "@ant-design/icons";

// const { Sider } = Layout;

// const SidebarMenu = ({ collapsed, onCollapse, activeKey, onMenuClick, profile }) => (
//   <Sider
//     collapsed={collapsed}
//     onCollapse={onCollapse}
//     width={200}
//     collapsedWidth={80}
//     className="user-profile-sider"
//   >
//     <Menu
//       mode="inline"
//       selectedKeys={[activeKey]}
//       onClick={({ key }) => onMenuClick(key)}
//       theme="dark"
//     >
//       <Menu.Item key="profile" icon={<UserOutlined />}>
//         Profile
//       </Menu.Item>
//       <Menu.Item key="event-types" icon={<UserOutlined />}>
//         Event Types
//       </Menu.Item>
//       {profile?.roles?.some((role) => role.name === "COMPANYREQUESTVALIDATOR") && (
//         <Menu.Item key="company-requests" icon={<PushpinOutlined />}>
//           Company Requests
//         </Menu.Item>
//       )}
//       {profile?.type === "Pro" && (
//         <>
//           <Menu.Item key="company-preferences" icon={<EnvironmentOutlined />}>
//             Preferences
//           </Menu.Item>
//           <Menu.Item key="company-settings" icon={<SettingOutlined />}>
//             Settings
//           </Menu.Item>
//         </>
//       )}
//     </Menu>
//   </Sider>
// );

// export default SidebarMenu;
